<template>
  <div>
    <div class="section-review-instructions">
      <div>
        <div><strong>Below is a summary of your answers.</strong></div>
        <div>The buttons in the lower left corner have three functions:</div>
        <ol>
          <li>Review all of your questions answered, incomplete and flagged.</li>
          <li>Review questions that are incomplete.</li>
          <li>Review questions that are flagged.</li>
        </ol>
      </div>
    </div>
    <div class="box-divider">
      <span>Test Questions</span>
      <span>({{ flashcardListStatuses.length }} Questions, {{ answeredCount }} Complete, {{ flashcardListStatuses.length - answeredCount }} Incomplete, {{ flaggedCount }} Flagged)</span>
    </div>
    <div class="section-review-container">
      <section-review-column
        :flashcard-list-statuses="column1"
        @navigate="navigate"
      />
      <section-review-column
        :flashcard-list-statuses="column2"
        :first-question-number="startColumn2 + 1"
        @navigate="navigate"
      />
      <section-review-column
        :flashcard-list-statuses="column3"
        :first-question-number="startColumn3 + 1"
        @navigate="navigate"
      />
    </div>
  </div>
</template>

<script>
import SectionReviewColumn from '@components/sims/sectionReview/SectionReviewColumn.vue';

export default {
  components: {
    SectionReviewColumn,
  },
  props: {
    flashcardListStatuses: {
      type: Array,
      required: true,
    },
  },
  computed: {
    answeredCount() {
      return this.flashcardListStatuses.filter( status => status.isAnswered).length;
    },
    column1() {
      return this.flashcardListStatuses.slice(0, this.startColumn2);
    },
    column2() {
      return this.flashcardListStatuses.slice(this.startColumn2, this.startColumn3);
    },
    column3() {
      return this.flashcardListStatuses.slice(this.startColumn3);
    },
    flaggedCount() {
      return this.flashcardListStatuses.filter( status => status.isBookmarked).length;
    },
    startColumn2() {
      return Math.ceil(this.flashcardListStatuses.length / 3);
    },
    startColumn3() {
      return Math.ceil(this.flashcardListStatuses.length / 3 * 2);
    },
  },
  methods: {
    navigate(flashcardId) {
      this.$emit('navigate', flashcardId);
    },
  },
};
</script>

<style lang="scss" scoped>
.section-review-instructions {
  padding: 1rem 0.75rem;

}
.box-divider {
  height: 2rem;
  background-color: #006AAC;
  margin: .5rem 0;
  font-size: 14px;
  font-weight: 600;
  color: white;
  line-height: 2rem;
  display: flex;
  justify-content: space-between;
  padding: 0 1.25rem;
}

.section-review-container {
  margin: 1rem 0.75rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
